import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

// Importer alle dine komponenter
import Login from './Login';
import NavigationBar from './NavigationBar';
import CensorerListe from './CensorerListe';
import OrganisationerListe from './OrganisationerListe';
import SprogcentreListe from './SprogcentreListe';
import HoldListe from './HoldListe';
import SettingsModal from './SettingsModal';
import KontaktpersonerListe from './KontaktpersonerListe';
import DokumentGenerering from './DokumentGenerering';

import './App.css';

console.log("🔥🔥🔥 REACT_APP_API_URL ER SAT TIL: ", process.env.REACT_APP_API_URL);

// Sæt app element for react-modal globalt (god praksis)
Modal.setAppElement('#root');

function App() {
  // State til at holde den loggede ind bruger
  const [user, setUser] = useState(null);
  // State til at vide, hvornår det indledende login-tjek er færdigt
  const [authChecked, setAuthChecked] = useState(false);
  // State for at styre settings-modalen
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false);

  // Tjekker login-status, når appen indlæses første gang
    useEffect(() => {
      const checkLoginStatus = async () => {
        const apiURL = `${process.env.REACT_APP_API_URL}/api/user/status`
        console.log("Vi kører Useeffect. apiURL er:")
        console.log("["+apiURL+"]")
        console.log("Vi kører Useeffect")

        try {
          const response = await fetch(apiURL, {
            credentials: 'include'
          });
          console.log("Status code:", response.status);
          const text = await response.text();
          console.log("Response body:", text);
          if (response.ok) {
            const userData = await response.json();
            setUser(userData);
          } else {
            console.log("else del af først useeffect")
              console.log("Server returned non-OK status:", response.status, text);

            setUser(null);
          }
        } catch (error) {
          console.log("der er en error "+ error)
          console.error('Kunne ikke tjekke login status', error);
          setUser(null);
        } finally {
          setAuthChecked(true); // Marker at vi er færdige med at tjekke
        }
      };
      checkLoginStatus();
    }, []); // Tomt array [] sikrer, at dette kun kører én gang

  // Funktioner til at håndtere login/logout
  const handleLoginSuccess = (loggedInUser) => {
    setUser(loggedInUser);
  };
  
  const handleLogout = async () => {
    try {
        await fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
          method: 'POST',
          credentials: 'include'
        });
    } catch (error) {
        console.error("Fejl ved logout:", error);
    } finally {
        setUser(null); // Fjern altid bruger fra state
    }
  };

  // Funktioner til at styre settings-modalen
  const openSettingsModal = () => setSettingsModalIsOpen(true);
  const closeSettingsModal = () => setSettingsModalIsOpen(false);

  // Navigation-logik
  const TABS = ['censorer', 'organisationer', 'sprogcentre', 'kontaktpersoner', 'hold', 'dokumentgenerering'];
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const handleTabChange = (tabName) => setActiveTab(tabName);

  // Funktion til at vælge, hvilken fane-komponent der skal vises
  const renderContent = () => {
    switch (activeTab) {
      case 'censorer':
        return <CensorerListe />;
      case 'organisationer':
        return <OrganisationerListe />;
      case 'sprogcentre':
        return <SprogcentreListe />;
      case 'kontaktpersoner':
        return <KontaktpersonerListe />;
      case 'hold':
        return <HoldListe />;
      case 'dokumentgenerering':
        return <DokumentGenerering />;
      default:
        return <p>Vælg venligst en fane.</p>;
    }
  };

  // --- Rendering Logik ---

  // 1. Vis en "Indlæser..." besked, indtil det første login-tjek er færdigt
  if (!authChecked) {
    return (
      <div className="app-container" style={{ textAlign: 'center' }}>
        <h2>Indlæser...</h2>
      </div>
    );
  }
  
  // 2. Hvis tjekket er færdigt, og der IKKE er en bruger, vis Login-siden
  if (!user) {
    console.log("No user found. ")
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }
  
  // 3. Hvis tjekket er færdigt, og der ER en bruger, vis den fulde applikation
  return (
    <div className="app-container">
      <div className="app-header">
        <h2 style={{ margin: 0 }}>Velkommen, {user.username}!</h2>
        <div className="header-actions">
          {/* Møtrik-ikon til at åbne indstillinger */}
          <button onClick={openSettingsModal} className="header-icon-button" title="Indstillinger">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
            </svg>
          </button>
          {/* Log ud knap */}
          <button onClick={handleLogout} className="header-button logout-button">Log Ud</button>
        </div>
      </div>

      <NavigationBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      
      {/* Selve Settings Modal'en (vises kun når isOpen er true) */}
      <SettingsModal
        isOpen={settingsModalIsOpen}
        onRequestClose={closeSettingsModal}
      />

      <div className="content-area">
        {renderContent()}
      </div>
    </div>
  );
}

export default App;